import React from 'react'
import PropTypes from 'prop-types'

const ChevronDown = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.0002 15.5C11.8686 15.5008 11.7381 15.4755 11.6163 15.4258C11.4944 15.376 11.3836 15.3027 11.2902 15.21L7.29019 11.21C7.19695 11.1168 7.12299 11.0061 7.07253 10.8843C7.02207 10.7624 6.99609 10.6319 6.99609 10.5C6.99609 10.3681 7.02207 10.2376 7.07253 10.1158C7.12299 9.99393 7.19695 9.88324 7.29019 9.79C7.38342 9.69676 7.49411 9.6228 7.61594 9.57234C7.73776 9.52188 7.86833 9.49591 8.00019 9.49591C8.13204 9.49591 8.26261 9.52188 8.38444 9.57234C8.50626 9.6228 8.61695 9.69676 8.71019 9.79L12.0002 13.1L15.3002 9.92C15.3922 9.81771 15.5043 9.7355 15.6295 9.67852C15.7547 9.62153 15.8903 9.59099 16.0279 9.58881C16.1654 9.58664 16.302 9.61286 16.4289 9.66585C16.5559 9.71884 16.6705 9.79746 16.7657 9.89678C16.8609 9.99611 16.9346 10.114 16.9821 10.2431C17.0297 10.3722 17.0501 10.5097 17.042 10.647C17.034 10.7844 16.9977 10.9186 16.9355 11.0413C16.8732 11.1639 16.7863 11.2724 16.6802 11.36L12.6802 15.22C12.4973 15.3963 12.2542 15.4964 12.0002 15.5Z'
      fill={color}
    />
  </svg>
)

ChevronDown.defaultProps = {
  color: 'currentColor',
  width: '24',
  height: '24',
}

ChevronDown.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default ChevronDown
